module.exports = __webpack_public_path__ + "img/bot-btn-new.8fb0f6b7.svg";